/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Custom tool call item: A call record for a custom tool with input payload and tool name.
 */
export type CustomToolCallWithId = {
  type: "custom_tool_call";
  callId: string;
  input: string;
  name: string;
  /**
   * The unique ID of the message.
   */
  id: string;
  /**
   * The ID of the response that created this item, if any.
   */
  responseId?: string | null | undefined;
  /**
   * Metadata from the response that created this item, if any.
   */
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const CustomToolCallWithId$inboundSchema: z.ZodType<
  CustomToolCallWithId,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("custom_tool_call"),
  call_id: z.string(),
  input: z.string(),
  name: z.string(),
  id: z.string(),
  response_id: z.nullable(z.string()).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    "call_id": "callId",
    "response_id": "responseId",
  });
});
/** @internal */
export type CustomToolCallWithId$Outbound = {
  type: "custom_tool_call";
  call_id: string;
  input: string;
  name: string;
  id: string;
  response_id?: string | null | undefined;
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const CustomToolCallWithId$outboundSchema: z.ZodType<
  CustomToolCallWithId$Outbound,
  z.ZodTypeDef,
  CustomToolCallWithId
> = z.object({
  type: z.literal("custom_tool_call"),
  callId: z.string(),
  input: z.string(),
  name: z.string(),
  id: z.string(),
  responseId: z.nullable(z.string()).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    callId: "call_id",
    responseId: "response_id",
  });
});

export function customToolCallWithIdToJSON(
  customToolCallWithId: CustomToolCallWithId,
): string {
  return JSON.stringify(
    CustomToolCallWithId$outboundSchema.parse(customToolCallWithId),
  );
}
export function customToolCallWithIdFromJSON(
  jsonString: string,
): SafeParseResult<CustomToolCallWithId, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CustomToolCallWithId$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CustomToolCallWithId' from JSON`,
  );
}
